import { MockedResponse } from '@apollo/client/testing';
import { GetKeptInspirationsDocument, type GetKeptInspirationsQuery, type GetKeptInspirationsQueryVariables } from '../../utils/hooks/getKeptInspirations';
import { mockKeptInspirations } from '../../mocks/inspiration';
export const createKeptInspirations = (count: number) => Array.from({
  length: count
}, (_, index) => {
  const source = mockKeptInspirations[index % mockKeptInspirations.length];
  const itemNumber = index + 1;
  return {
    ...source,
    __typename: 'KeptInspiration' as const,
    id: `kept-${itemNumber}`,
    contentId: `content-${itemNumber}`,
    note: index % 2 === 0 ? `Pinned inspiration note ${itemNumber}` : source.note ?? null
  };
});
export const createGetKeptInspirationsMock = ({
  items,
  variables = {
    first: 20
  }
}: {
  items: ReturnType<typeof createKeptInspirations>;
  variables?: GetKeptInspirationsQueryVariables;
}): MockedResponse<GetKeptInspirationsQuery> => ({
  request: {
    query: GetKeptInspirationsDocument,
    variables
  },
  result: {
    data: {
      client: {
        __typename: 'Client',
        keptInspirations: {
          __typename: 'KeptInspirationConnection',
          nodes: items,
          pageInfo: {
            __typename: 'PageInfo',
            endCursor: null,
            hasNextPage: false,
            hasPreviousPage: false,
            startCursor: items[0]?.id ?? null
          }
        }
      }
    }
  }
});